__turbopack_context__.v({
  "buySectionContainer": "BuySectionInfo-module__n7AdlW__buySectionContainer",
  "offerFlexContainer": "BuySectionInfo-module__n7AdlW__offerFlexContainer",
  "offerTag": "BuySectionInfo-module__n7AdlW__offerTag",
  "priceContainer": "BuySectionInfo-module__n7AdlW__priceContainer",
});
